/**
 * Created by tomers on 5/19/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/users/userEdit.tmpl");
    var PermissionGroupBubbleView = require("user-management-views/users/UserEditPermissionGroupBubbleView");
    var PictureUrlBubbleView = require("user-management-views/users/UserEditPictureUrlBubbleView");
    var UserEditMaxConversationsAccountView = require("user-management-views/users/UserEditMaxConversationsAccountView");
    var UserEditMaxConversationsCustomView = require("user-management-views/users/UserEditMaxConversationsCustomView");


    var RadioButtonList = require("ui/radio-button-list/RadioButtonList");
    var InputField = require("ui/input-field/InputField");
    var Dropdown = require("ui/dropdown/Dropdown");
    var ToggleButton = require("ui/toggle-button/toggleButton");
    var Multiselect = require("ui/multiselect/Multiselect");
    var Button = require("ui/button/Button");
    var Bubble = require("ui/bubble/Bubble");
    var SingleSelect = require("ui/singleselect-new/Singleselect");

    var RETYPE_PASSWORD_ERROR_KEY = "retypePassword";

    var UserEditView = {};

    var MAX_CONVERSATIONS_TYPE = {
        ACCOUNT_SETTINGS: 0,
        CUSTOM_SETTINGS: 1
    };

    var URLS = {
        AVATAR_PICTURE:  window.leImageBaseUrl + "src/modules/user-management/assets/img/avatar200x200.png",
        BROKEN_URL_PICTURE: window.leImageBaseUrl + "src/modules/user-management/assets/img/broken-image.png"
    };

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        UserEditView = Marionette.ItemView.extend({
            className: "user-edit",
            template: template,
            ui:{
                loginName: ".login-name-container .input-container",
                email: ".email-container .input-container",
                nickName: ".nick-name-container .input-container",
                displayName: ".display-name-container .input-container",
                employeeId: ".employee-id-container .input-container",
                permissionGroup: ".permission-group-container .input-container",
                permissionGroupIcon: ".permission-group-container .icon",
                enabled: ".enabled-container .input-container",
                maxChats: ".max-chats-container .input-container",
                maxConversationsContainer: ".max-conversations-container",
                maxConversationRadioButtonList: ".max-conversations-container .max-conversation-radio-button-list",
                maxConversations: ".max-conversations-container .input-container",
                skills: ".skills-container .input-container",
                currentPasswordSection: ".current-password-container",
                currentPassword: ".current-password-container .input-container",
                newPassword: ".new-password-container .input-container",
                retypePassword: ".retype-password-container .input-container",
                changePasswordContainer: ".change-password-container",
                changePasswordNextLogin: ".change-password-container .input-container",
                cancelButton: ".cancel-button",
                saveButton: ".save-button",
                memberOfSelect: ".member-of-select",
                memberOfSelectContainer: ".member-of-select-container",
                memberOfInputField: ".member-of-select-container .input-field",
                managerOfSelect: ".manager-of-select",
                managerOfSelectContainer: ".manager-of-select-container",
                pictureUrlInput: ".picture-url-container .input-container",
                pictureUrlIcon: ".picture-url-container .icon",
                picturePreview: ".picture-preview-container img",
                employeeIdContainer: ".employee-id-container"
            },
            uiComponents: {
                loginName: {
                    type: InputField,
                    options: {
                        el: "view.ui.loginName",
                        permutation: InputField.Permutation.B,
                        placeholder: LE.translator.translate("LEUserManagement.userEdit.loginName.placeholder.new")
                    },
                    events: {
                        change: "_onLoginNameChange"
                    }
                },
                email: {
                    type: InputField,
                    options: {
                        el: "view.ui.email",
                        permutation: InputField.Permutation.B,
                        placeholder: LE.translator.translate("LEUserManagement.userEdit.email.placeholder")
                    },
                    events: {
                        change: "_onEmailChange"
                    }
                },
                nickName: {
                    type: InputField,
                    options: {
                        el: "view.ui.nickName",
                        permutation: InputField.Permutation.B,
                        placeholder: LE.translator.translate("LEUserManagement.userEdit.nickName.placeholder")
                    },
                    events: {
                        change: "_onNickNameChange"
                    }
                },
                displayName: {
                    type: InputField,
                    options: {
                        el: "view.ui.displayName",
                        permutation: InputField.Permutation.B,
                        placeholder: LE.translator.translate("LEUserManagement.userEdit.displayName.placeholder")
                    },
                    events: {
                        change: "_onDisplayNameChange"
                    }
                },
                employeeId: {
                    type: InputField,
                    options: {
                        el: "view.ui.employeeId",
                        permutation: InputField.Permutation.B,
                        maxLength: "view.modelValidators.maxEmployeeIdLength",
                        placeholder: LE.translator.translate("LEUserManagement.userEdit.employeeId.placeholder")
                    },
                    events: {
                        change: "_onEmployeeIdChange"
                    }
                },
                pictureUrl: {
                    type: InputField,
                    options: {
                        el: "view.ui.pictureUrlInput",
                        permutation: InputField.Permutation.B,
                        maxLength: "view.modelValidators.maxPictureUrlLength",
                        placeholder: LE.translator.translate("LEUserManagement.userEdit.pictureUrl.placeholder")
                    },
                    events: {
                        onblur: "_onPictureUrlBlur",
                        change: "_onPictureUrlChange"
                    }
                },
                permissionGroup: {
                    type: Dropdown,
                    options: {
                        name: "permissionGroup",
                        container: "view.ui.permissionGroup",
                        permutation: Dropdown.PERMUTATION.MEDIUM,
                        items: "view._getPermissionGroupItems"
                    },
                    events: {
                        change: "_onPermissionGroupChange"
                    }
                },
                memberSingleSelect: {
                    type: SingleSelect,
                    options: {
                        container: "view.ui.memberOfSelect",
                        permutation: SingleSelect.PERMUTATION.B,
                        theme: SingleSelect.THEME.DEFAULT,
                        errorPosition: SingleSelect.ERROR_POSITION.RIGHT,
                        inputField: {
                            placeholder: LE.translator.translate("LEUserManagement.userEdit.assignedToGroup.placeholder")
                        },
                        items : "view._getGroupsItems"
                    }
                },
                enabled: {
                    type: ToggleButton,
                    options: {
                        container: "view.ui.enabled",
                        transition: ToggleButton.TRANSITION.FAST
                    },
                    events: {
                        "toggleButton:change": "_onEnabledChange"
                    }
                },
                maxChats: {
                    type: Dropdown,
                    options: {
                        name: "maxChats",
                        container: "view.ui.maxChats",
                        permutation: Dropdown.PERMUTATION.MEDIUM,
                        testCollision: true,
                        items: "view._getMaxChatsItems"
                    },
                    events: {
                        change: "_onMaxChatsChange"
                    }
                },
                skills: {
                    type: Multiselect,
                    options: {
                        container: "view.ui.skills",
                        permutation: Multiselect.PERMUTATION.MEDIUM,
                        trim: true,
                        list: {
                            newItem: {
                                visible: true,
                                value: LE.translator.translate("LEUserManagement.userEdit.skills.create.label")
                            }
                        },
                        tagsContainer: {
                            placeholder: LE.translator.translate("LEUserManagement.userEdit.skills.placeholder"),
                            tagMaxWidth: "275px"
                        },
                        items: "view._getSkillsItems"
                    },
                    events: {
                        create: "_onSkillsCreate",
                        select: "_onSkillsChange",
                        unselect: "_onSkillsChange"
                    }
                },
                manageGroups: {
                    type: Multiselect,
                    options: {
                        container: "view.ui.managerOfSelect",
                        permutation: Multiselect.PERMUTATION.MEDIUM,
                        trim: true,
                        list: {
                            noItems: {
                                visible: true,
                                value: LE.translator.translate("LEUserManagement.userEdit.manageGroups.noItems.placeholder")
                            }
                        },
                        tagsContainer: {
                            placeholder: LE.translator.translate("LEUserManagement.userEdit.manageGroups.placeholder"),
                            inlineErrorText: LE.translator.translate("LEFramework.entities.user.errors.assignToGroup.notFromList"),
                            tagMaxWidth: "275px",
                            maxShownLines: 2
                        },
                        items: "view._getAgentGroups"
                    },
                    events: {
                        //create: "_onManagerCreate",
                        select: "_onManagerChange",
                        unselect: "_onManagerChange"
                    }
                },

                newPassword: {
                    type: InputField,
                    options: {
                        el: "view.ui.newPassword",
                        permutation: InputField.Permutation.B,
                        type: InputField.Type.Password,
                        placeholder: "view._getPasswordPlaceholder"
                    },
                    events: {
                        change: "_onNewPasswordChange"
                    }
                },
                retypePassword: {
                    type: InputField,
                    options: {
                        el: "view.ui.retypePassword",
                        permutation: InputField.Permutation.B,
                        type: InputField.Type.Password
                    },
                    events: {
                        change: "_onRetypePasswordChange"
                    }
                },
                changePasswordNextLogin: {
                    type: ToggleButton,
                    options: {
                        container: "view.ui.changePasswordNextLogin",
                        transition: ToggleButton.TRANSITION.FAST
                    },
                    events: {
                        "toggleButton:change": "_onChangePasswordNextLoginChange"
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_onCancel"
                    }
                },
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onSave"
                    }
                }
            },
            events: {
                "mouseenter @ui.permissionGroupIcon": "_showPermissionGroupBubble",
                "mouseleave @ui.permissionGroupIcon": "_closePermissionGroupBubble",
                "mouseenter @ui.pictureUrlIcon": "_showPictureUrlBubble",
                "mouseleave @ui.pictureUrlIcon": "_closePictureUrlBubble"
            },
            modelEvents: {
                "change": "_onModelChange"
            },

            URLS: URLS,

            //<editor-fold desc="Marionette-Functions">
            /*-----------------------------------------------------------------------------------------------*/
            initialize: function(options) {
                this._initialize(options);
            },
            onRender: function() {
                this._onRender();
            },
            //</editor-fold>

            //<editor-fold desc="publicFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            validateView: function() {
                return this._validateView();
            },
            //</editor-fold>


            //<editor-fold desc="privateFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            _initialize: function(options) {
                options = options || {};
                this.model = options.model;
                this.modelValidators = this.model.MODEL_VALIDATORS;
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.USER_EDIT);

                this.isMyUser = options.isMyUser;
                this.skillsCollection = LEUserManagement.getDataManager().getSkillsCollection();
                this.permissionGroupsCollection = LEUserManagement.getDataManager().getPermissionGroupsCollection();
                this.agentGroupsCollection =  LEUserManagement.getDataManager().getAgentGroupsCollection();
                this.initMemberAndManagerOfFields = options.memberAndManagerOfStatus;
                this.isEmployeeIdFieldHidden = options.employeeIdStatus;
                this.showMaxConversations = options.showMaxConversations || false;
                this.maxConversationsSettings = !_.isUndefined(options.maxConversationsSettings) ? options.maxConversationsSettings : null;
            },

            _onRender: function() {
                this._bindEvents();
                this._renderCurrentPassword();
                this._updateLoginName();
                this._updateEmail();
                this._updateNickName();
                this._updateDisplayName();
                this._manageEmployeeIdStatus();
                this._updatePictureUrl();
                this._updatePermissionGroup();
                this._updateEnabled();
                this._updateMaxChats();
                this._renderMaxConversationsRadioButtonList();
                this._updateSaveButtonState();
                this._checkMemberAndManagerOfFieldStatus();
                this._updateChangePasswordNextLogin();
                this._setFocus();
            },

            _bindEvents: function() {
                this.listenTo(this.channel.vent, "user:skill:create:success", this._onSkillCreateSuccess);
                this.listenTo(this.channel.vent, "user:skill:create:error", this._onSkillCreateError);
                this.listenTo(this.channel.vent, "user:save:success", this._onSaveSuccess);
                this.listenTo(this.channel.vent, "user:save:error", this._onSaveError);
            },

            _renderCurrentPassword: function() {
                if (this.isMyUser) {
                    this.ui.currentPasswordSection.removeClass("hide");
                    this.uiComponents.host$.createAndRender("currentPassword", {
                        type: InputField,
                        options: {
                            el: "view.ui.currentPassword",
                            permutation: InputField.Permutation.B,
                            type: InputField.Type.Password,
                            placeholder: LE.translator.translate("LEUserManagement.userEdit.currentPassword.placeholder")
                        },
                        events: {
                            change: "_onCurrentPasswordChange"
                        }
                    });
                }
            },

            _checkMemberAndManagerOfFieldStatus: function() {
                this.manageMemberOfFieldStatus(this.initMemberAndManagerOfFields.showMemberField);
                this.manageManagerOfFieldStatus(this.initMemberAndManagerOfFields.showManagerOfField);
            },

            _manageEmployeeIdStatus: function () {
                this.employeeIdStatus(this.isEmployeeIdFieldHidden);
                if(!this.isEmployeeIdFieldHidden){
                    this.uiComponents.employeeId.setValue(this.model.getEmployeeId());
                }
            },

            manageManagerOfFieldStatus: function(status) {
                if (status) {
                    this.ui.managerOfSelectContainer.removeClass("hide");
                } else {
                    this.ui.managerOfSelectContainer.addClass("hide");
                }
            },


            employeeIdStatus: function(status) {
                this.ui.employeeIdContainer.toggleClass("hide", status);
            },

            manageMemberOfFieldStatus: function(status) {
               if (status) {
                   var memberOfValue = this._isMemberOf();
                  if (memberOfValue) {
                      this.uiComponents.memberSingleSelect.setInputValue(memberOfValue);
                  }
                   this.ui.memberOfSelectContainer.removeClass("hide");
                   this.listenTo(this.uiComponents.memberSingleSelect, SingleSelect.TRIGGERING.INPUT_CHANGE, this._onGroupInputChange);
                   this.listenTo(this.uiComponents.memberSingleSelect, SingleSelect.TRIGGERING.CHANGE, this._onGroupSelect);
                   this.isMemberSingleSelectInputChanged = false;
                   this.listenTo(this.uiComponents.memberSingleSelect, SingleSelect.TRIGGERING.BLUR, this._onGroupBlur);
               } else {
                   this.stopListening(this.uiComponents.memberSingleSelect, SingleSelect.TRIGGERING.INPUT_CHANGE);
                   this.stopListening(this.uiComponents.memberSingleSelect, SingleSelect.TRIGGERING.CHANGE);
                   this.stopListening(this.uiComponents.memberSingleSelect, SingleSelect.TRIGGERING.BLUR);
                   this.ui.memberOfSelectContainer.addClass("hide");
               }
            },

            _isMemberOf: function() {
                var memberOf = this.model.getMemberOfGroup();

                if (memberOf) {
                    var groupCollection = this._getGroupsItems();
                    _.each(groupCollection, function(group){
                        if (group.id === memberOf){
                            memberOf = group.value;
                            return;
                        }
                    });
                    return memberOf;
                } else {
                    return null;
                }
            },

            _setFocus: function() {
                var focusedComponent = (this.model.isNew()) ? this.uiComponents.loginName : this.uiComponents.email;
                focusedComponent.setFocus(true);
            },

            _updateLoginName: function() {
                this.uiComponents.loginName.setValue(this.model.getLoginName());
                if (!this.model.isNew()) {
                    this.uiComponents.loginName.setEnabled(false);
                }
            },
            _updateEmail: function() {
                this.uiComponents.email.setValue(this.model.getEmail());
            },
            _updateNickName: function() {
                this.uiComponents.nickName.setValue(this.model.getNickName());
            },
            _updateDisplayName: function() {
                this.uiComponents.displayName.setValue(this.model.getDisplayName());
            },

            _updatePictureUrl: function() {
                var pictureUrl = this.model.getPictureUrl();
                if (!pictureUrl) {
                    pictureUrl = "";
                }
                this.uiComponents.pictureUrl.setValue(pictureUrl);
                if (pictureUrl === "") {
                    this.ui.picturePreview.attr("src", URLS.AVATAR_PICTURE);
                } else {
                    this.ui.picturePreview.attr("src", pictureUrl);
                }
            },
            _updatePermissionGroup: function() {
                this.uiComponents.permissionGroup.setSelection(this.model.getPermissionGroup());
            },
            _updateEnabled: function() {
                this.uiComponents.enabled.setChecked(this.model.getEnabled());
                if (this.isMyUser) {
                    this.uiComponents.enabled.setEnabled(false);
                }
            },
            _updateMaxChats: function() {
                this.uiComponents.maxChats.setSelection(this.model.getMaxNumberOfChats());
            },
            _updateChangePasswordNextLogin: function() {
                this.uiComponents.changePasswordNextLogin.setChecked(this.model.getChangePasswordNextLogin());
                if (this.isMyUser || this.model.getIsLegacy()) {
                    this.uiComponents.changePasswordNextLogin.setEnabled(false);
                    this.ui.changePasswordContainer.addClass("hide");
                }
            },
            _onLoginNameChange: function(componentId, eventName, loginName) {
                this.channel.trigger("user:change:loginName", loginName);
            },
            _onEmailChange: function(componentId, eventName, email) {
                this.channel.trigger("user:change:email", email);
            },

            _onNickNameChange: function(componentId, eventName, nickName) {
                this.channel.trigger("user:change:nickName", nickName);
            },

            _onDisplayNameChange: function(componentId, eventName, displayName) {
                this.channel.trigger("user:change:displayName", displayName);
            },

            _onEmployeeIdChange: function(componentId, eventName, employeeId) {
                this.channel.trigger("user:change:employeeId", employeeId);
            },

            _onPictureUrlBlur: function(componentId, eventName, obj) {
                this.blurTimeout = setTimeout(_.bind(function(){
                    this.channel.trigger("user:blur:pictureUrl", {value: obj, origin: "fieldBlur"});
                }, this), 200);
             },

            _onPictureUrlChange: function(componentId, eventName, obj) {
                this.channel.trigger("user:change:pictureUrl");
            },

            _onPermissionGroupChange: function(componentId, eventName, obj) {
                this.channel.trigger("user:change:permissionGroup", obj.selectedKey);
            },

            _onEnabledChange: function(componentId, eventName, enabled) {
                this.channel.trigger("user:change:enabled", enabled);
            },

            _onMaxChatsChange: function(componentId, eventName, obj) {
                this.channel.trigger("user:change:maxNumberOfChats", obj.selectedKey);
            },

            _onSkillsCreate: function(componentId, eventName, obj) {
                this.uiComponents.skills.discardInput();
                this.channel.trigger("user:skill:create", obj.value);
            },

            _onSkillCreateSuccess: function(skillModel) {
                this.uiComponents.skills.addItem({
                    id: skillModel.id,
                    value: skillModel.getName(),
                    selected: true
                });
                this.uiComponents.skills.setFocus();
                this._onSkillsChange();
            },

            _onSkillCreateError: function(errorObject) {
                if (!_.isEmpty(errorObject)) {
                    var errors = {};
                    errors[this.model.KEYS.SKILLS] = _.values(errorObject)[0];
                    this._setErrors(errors);
                }
            },

            _onSkillsChange: function(componentId, eventName, item) {
                var skills = this.uiComponents.skills.getSelectedItems();
                this.channel.trigger("user:change:skills", skills);
            },

            _onGroupSelect: function(data) {
                this.channel.trigger("user:change:memberSingleSelect", data.item.id);
            },

            _onManagerChange: function(componentId, eventName, item) {
                this.channel.trigger("user:change:managerOfGroups", item);
            },

            _onCurrentPasswordChange: function(componentId, eventName, password) {
                this.channel.trigger("user:change:oldPassword", password);
            },

            _onNewPasswordChange: function(componentId, eventName, password) {
                this.channel.trigger("user:change:password", password);
            },

            _onRetypePasswordChange: function(componentId, eventName, password) {
                this._updateSaveButtonState({valueChanged:true});
            },
            _onChangePasswordNextLoginChange: function(componentId, eventName, changePwdNextLogin) {
                this.channel.trigger("user:change:changePasswordNextLogin", changePwdNextLogin);
            },

            _onModelChange: function() {
                this._updateSaveButtonState({valueChanged:true});
            },

            _showPermissionGroupBubble: function() {
                this._closePermissionGroupBubble(null, true);
                this.uiComponents.host$.createAndRender("permissionGroupBubble", {
                    type: Bubble,
                    options: {
                        targetControl: this.ui.permissionGroupIcon,
                        position: Bubble.POSITION.RIGHT,
                        showCloseButton: false,
                        isDelayed: true,
                        contentView: new PermissionGroupBubbleView(this._getPermissionGroupKeysArr())
                    }
                });
            },

            _closePermissionGroupBubble: function(event, force) {
                if (this.uiComponents.permissionGroupBubble) {
                    this.uiComponents.permissionGroupBubble.close(force);
                }
            },

            _showPictureUrlBubble: function() {
                this._closePictureUrlBubble(null, true);
                this.uiComponents.host$.createAndRender("pictureUrlBubble", {
                    type: Bubble,
                    options: {
                        targetControl: this.ui.pictureUrlIcon,
                        position: Bubble.POSITION.RIGHT,
                        showCloseButton: false,
                        isDelayed: true,
                        contentView: new PictureUrlBubbleView()
                    }
                });
            },

            _renderMaxConversationsRadioButtonList: function() {
                if (this.showMaxConversations) {
                    this.ui.maxConversationsContainer.removeClass("hide");
                    this.uiComponents.host$.createAndRender("maxConversationRadioButtonList", {
                        type: RadioButtonList,
                        options: {
                            el: "view.ui.maxConversationRadioButtonList",
                            items: "view._getMaxConversationRadioButtonItems",
                            permutation: RadioButtonList.PERMUTATION.D,
                            defaultSelection: "view._getSelectedMaxConversationOption"
                        },
                        events: {
                            change: "_onMaxConversationRadioButtonListChange"
                        }
                    });

                    this._toggleMaxConversationCustomInput();
                }
            },

            _getSelectedMaxConversationOption: function() {
                var userModelMaxConversationSettings = this.model.getMaxConversations();
                var selectedOption = (_.isNull(userModelMaxConversationSettings)) ? MAX_CONVERSATIONS_TYPE.ACCOUNT_SETTINGS :
                    MAX_CONVERSATIONS_TYPE.CUSTOM_SETTINGS;

                return selectedOption;
            },

            _onMaxConversationRadioButtonListChange: function() {
                if(this.uiComponents.maxConversationRadioButtonList.getSelectedKey() === MAX_CONVERSATIONS_TYPE.ACCOUNT_SETTINGS) {
                    this.channel.trigger("user:change:maxConversations", null);
                    this.userEditMaxConversationsCustomView.clearCustomConfigurationInputField();
                }
                this._toggleMaxConversationCustomInput();
                this._updateSaveButtonState({valueChanged:true});
            },

            _getMaxConversationRadioButtonItems: function () {
                this.userEditMaxConversationsAccountView = new UserEditMaxConversationsAccountView({maxConversationsSettings: this.maxConversationsSettings});
                this.userEditMaxConversationsCustomView = new UserEditMaxConversationsCustomView({model: this.model, channel: this.channel});
                var items =[
                    {
                        key: MAX_CONVERSATIONS_TYPE.ACCOUNT_SETTINGS,
                        embeddedView: this.userEditMaxConversationsAccountView
                    },
                    {
                        key: MAX_CONVERSATIONS_TYPE.CUSTOM_SETTINGS,
                        embeddedView: this.userEditMaxConversationsCustomView
                    }
                ];
                return items;
            },

            _toggleMaxConversationCustomInput: function () {
                var showCustomInput = (this.uiComponents.maxConversationRadioButtonList.getSelectedKey() === MAX_CONVERSATIONS_TYPE.CUSTOM_SETTINGS);
                this.userEditMaxConversationsCustomView.showCustomConfigurationInputField(showCustomInput);
            },

            _closePictureUrlBubble: function(event, force) {
                if (this.uiComponents.pictureUrlBubble) {
                    this.uiComponents.pictureUrlBubble.close(force);
                }
            },

            _updateSaveButtonState: function(options) {
                options = options || {};
                var isSaveEnabled = this.model.validateSaveEnabled() && this._validateViewSaveEnabled();

                if (!isSaveEnabled) {
                    this.uiComponents.saveButton.setEnabled(false);
                    var mandatoryFieldsErrorKey = (this.model.isNew()) ? "newUser" : "editUser";
                    this.uiComponents.saveButton.setTooltip(LE.translator.translate("LEUserManagement.userEdit.saveButton.tooltip.mandatoryFields." + mandatoryFieldsErrorKey));
                }
                else {
                    if (options.valueChanged) {
                        this.uiComponents.saveButton.setEnabled(true);
                        this.uiComponents.saveButton.setTooltip("");
                    }
                    else {
                        this.uiComponents.saveButton.setEnabled(false);
                        this.uiComponents.saveButton.setTooltip(LE.translator.translate("LEUserManagement.userEdit.saveButton.tooltip.noChanges"));
                    }
                }
            },

            _getPermissionGroupItems: function() {
                var permissionGroupArr = [];
                this.permissionGroupsCollection.each(function(permissionGroupModel) {
                    var permissionGroupObj = {
                        key: parseInt(permissionGroupModel.id, 10), // we parse it because the id on the userModel is saved as a number and not as a string
                        value: LE.translator.translate("LEUserManagement.permissionGroup." + permissionGroupModel.getModelKey() + ".name")
                    };
                    permissionGroupArr.push(permissionGroupObj);
                }, this);

                return new Dropdown.Collection(permissionGroupArr);
            },

            // change the loop inside a loop
            _getAgentGroups: function() {
                var agentGroupsArr = [];
                var agentGroupCollectionCopy = new Backbone.Collection();
                this.agentGroupsCollection.each(function(groupModel) {
                    agentGroupCollectionCopy.add(new Backbone.Model(groupModel.toJSON()));
                });
                var managers = this.model.getManagerOfGroup();
                _.each(managers, function(manager){
                    var managerGroup = agentGroupCollectionCopy.get(manager.agentGroupId);
                    agentGroupsArr.push({
                        id: managerGroup.get("id"),
                        value: managerGroup.get("name"),
                        selected: true
                    });
                    agentGroupCollectionCopy.remove(manager.agentGroupId);

                });
                _.each(agentGroupCollectionCopy.models, function(group){
                    agentGroupsArr.push({
                        id: group.get("id"),
                        value: group.get("name"),
                        selected: false
                    });
                });

                return agentGroupsArr;
            },

            _getPermissionGroupKeysArr: function() {
                var permissionGroupArr = [];

                this.permissionGroupsCollection.each(function(permissionGroupModel) {
                    permissionGroupArr.push(permissionGroupModel.getModelKey());
                }, this);

                return {permissionGroups:permissionGroupArr};
            },

            _getMaxChatsItems: function() {
                var maxChatsArr = [];
                maxChatsArr.push({
                    key: this.model.MAX_CHATS_CONST.NO_CHATS,
                    value: LE.translator.translate("LEUserManagement.userEdit.maxChats.noChats.label")
                });
                _.each(_.range(1,11), function(number){
                    maxChatsArr.push({key:number.toString(), value:number.toString()}); // we "toString" it because the value in the userModel is saved as a string
                });
                maxChatsArr.push({
                    key: this.model.MAX_CHATS_CONST.UNLIMITED,
                    value: LE.translator.translate("LEUserManagement.userEdit.maxChats.unlimited.label")
                });

                return new Dropdown.Collection(maxChatsArr);
            },

            _getSkillsItems: function() {
                var skillsArr = [];
                this.skillsCollection.each(function(skillModel) {
                    skillsArr.push({
                        id: skillModel.id,
                        value: skillModel.getName(),
                        selected: _.include(this.model.getSkills(), skillModel.id)
                    });
                }, this);

                return skillsArr;
            },

            _getGroupsItems: function() {
                var groupsArr = [];
                this.agentGroupsCollection.each(function(group) {
                    groupsArr.push({
                        id: group.id,
                        value: group.getName()
                    });
                }, this);

                return groupsArr;
            },

            _getPasswordPlaceholder: function() {
                var passwordPlaceholder = (this.model.isNew() || this.isMyUser) ? "" : LE.translator.translate("LEUserManagement.userEdit.newPassword.placeholder");
                return passwordPlaceholder;
            },

            _validateViewSaveEnabled: function() {
                var isValid = true;

                if (this.model.isNew() && (_.isEmpty(this.uiComponents.newPassword.getValue()) || _.isEmpty(this.uiComponents.retypePassword.getValue()))) {
                    isValid = false;
                }

                if (this.showMaxConversations && this.uiComponents.maxConversationRadioButtonList.getSelectedKey() === MAX_CONVERSATIONS_TYPE.CUSTOM_SETTINGS &&
                    _.isNull(this.model.getMaxConversations())){

                    isValid = false;
                }

                return isValid;
            },

            _onGroupBlur : function () {
                if( this.isMemberSingleSelectInputChanged) {
                    var memberObj = this.uiComponents.memberSingleSelect.getSelectedItem();  //todo: errors should be in model
                    if (_.isEmpty(memberObj)) {
                        this.uiComponents.memberSingleSelect.setError(true, LE.translator.translate("LEFramework.entities.user.errors.assignToGroup.notFromList"));
                        this.channel.trigger("user:change:memberSingleSelect", null);
                    } else {
                        this.channel.trigger("user:change:memberSingleSelect", memberObj.id);
                    }
                }
            },

            _validateView: function() {
                var errorsObj = {};

                if (this.model.getPassword() && this.uiComponents.retypePassword.getValue() !== this.model.getPassword())  {
                    errorsObj[RETYPE_PASSWORD_ERROR_KEY] = "LEUserManagement.userEdit.retypePassword.error.notMatch";
                }

                return errorsObj;
            },

            _onCancel: function() {
                clearTimeout(this.blurTimeout);
                this.channel.trigger("user:cancel");
            },

            _onSave: function() {
                this.channel.trigger("user:save", {origin: "save"});
            },

            _onSaveSuccess: function() {
                this._hideErrors();
            },

            _onSaveError: function(errors) {
                this._setErrors(errors);
            },

            _onGroupInputChange: function(value) {
                this.channel.trigger("user:change:memberSingleSelect", null);
                this.isMemberSingleSelectInputChanged = true;
            },

            _setErrors: function(errors) {
                this._hideErrors();

                this.errorsOnPage = errors;

                var keys = this.model.getKeys();
                var errorCodes = this.model.getErrorCodes();

                if (_.has(errors, keys.EMAIL_ADDRESS)) {
                    this.uiComponents.email.setError(true, errors[keys.EMAIL_ADDRESS]);
                }

                if (_.has(errors, keys.LOGIN_NAME)) {
                    this.uiComponents.loginName.setError(true, errors[keys.LOGIN_NAME]);
                }

                if (_.has(errors, keys.NICK_NAME)) {
                    this.uiComponents.nickName.setError(true, errors[keys.NICK_NAME]);
                }

                if (_.has(errors, keys.DISPLAY_NAME)) {
                    this.uiComponents.displayName.setError(true, errors[keys.DISPLAY_NAME]);
                }

                if (_.has(errors, RETYPE_PASSWORD_ERROR_KEY)) {
                    this.uiComponents.retypePassword.setError(true, errors[RETYPE_PASSWORD_ERROR_KEY]);
                    this.uiComponents.newPassword.setError(true, errors[RETYPE_PASSWORD_ERROR_KEY]);
                }

                if (_.has(errors, keys.PASSWORD)) {
                    this.uiComponents.newPassword.setError(true, errors[keys.PASSWORD]);
                }

                if (_.has(errors, keys.OLD_PASSWORD) && this.uiComponents.currentPassword) {
                    this.uiComponents.currentPassword.setError(true, errors[keys.OLD_PASSWORD]);
                }
                if (_.has(errors, keys.MEMBER_OF)) {
                    this.uiComponents.memberSingleSelect.setError(true, errors[keys.MEMBER_OF]);
                }
                if (_.has(errors, errorCodes.PASSWORD_RESTRICTIONS)) {
                    this.uiComponents.newPassword.setError(true, errors[errorCodes.PASSWORD_RESTRICTIONS]);
                }
                if (_.has(errors, keys.PICTURE_URL)) {
                    this.uiComponents.pictureUrl.setError(true, errors[keys.PICTURE_URL]);
                }
                if (_.has(errors, keys.INVALID_PICTURE_URL)) {
                    this.uiComponents.pictureUrl.setError(true, errors[keys.INVALID_PICTURE_URL]);
                }
                if (_.has(errors, keys.UNSUPPORTED_PICTURE_FORMAT)) {
                    this.uiComponents.pictureUrl.setError(true, errors[keys.UNSUPPORTED_PICTURE_FORMAT]);
                }
            },

            _hideErrors: function () {
                this.errorsOnPage = null;
                this.uiComponents.loginName.setError(false);
                this.uiComponents.email.setError(false);
                this.uiComponents.nickName.setError(false);
                this.uiComponents.displayName.setError(false);
                this.uiComponents.newPassword.setError(false);
                this.uiComponents.retypePassword.setError(false);
                if (this.uiComponents.currentPassword) {
                    this.uiComponents.currentPassword.setError(false);
                }
                this.uiComponents.memberSingleSelect.setError(false);
                this.uiComponents.pictureUrl.setError(false);
            }

            //</editor-fold>
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return UserEditView;

});

